import { makeStyles, createStyles } from '@material-ui/core';
import { gray60Color } from '../../utils/styled-components/color-mixins/color-mixins';
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            color: gray60Color({ theme: { velocity: theme.velocity } }),
            fontSize: theme.typography.caption.fontSize,
            lineHeight: theme.typography.caption.lineHeight,
        },
        separator: {
            fontWeight: 'bold',
        },
    });
});
//# sourceMappingURL=Breadcrumbs.styled.js.map